import { Outlet } from "react-router"
import inquiryStyle from "./inquiry.module.css"


export default function Inquiry() {
    return(
        <div
            id="inquiry"
            className={inquiryStyle.inquiry}
        >
            <Outlet></Outlet>
        </div>
    )
}